import React from 'react';
import { Tooltip } from 'reactstrap';

class TooltipItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tooltipOpen: false,
    };
  }
  toggle = () => {
    this.setState(prevState => ({
      tooltipOpen: !prevState.tooltipOpen,
    }));
  };

  render() {
    return (
      <span>
        <button
          id={'Tooltip-' + this.props.id}
          style={{
            borderRadius: '100%',
            height: '18px',
            width: '18px',
            fontSize: '9px',
            padding: '0 0 0 1px',
          }}
        >
          {this.props.item.text}
        </button>
        <Tooltip
          placement={this.props.item.placement}
          isOpen={this.state.tooltipOpen}
          target={'Tooltip-' + this.props.id}
          toggle={this.toggle}
        >
          {this.props.item.body}
        </Tooltip>
      </span>
    );
  }
}
export default TooltipItem;
